/*
 * @Author: houmy
 * @Date: 2023-08-29 18:44:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-10-19 11:16:24
 * @FilePath: \zx-home\src\router\index.js
 * @Description: 
 * 
 */
import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import Products from '../views/Products.vue';
import ProductsDetail from '../views/ProductsDetail.vue';
import ModelDetail from '../views/ModelDetail.vue';
import Solution from '../views/Solution.vue';
import SolutionDetail from '../views/SolutionDetail.vue';
import Support from '../views/Support.vue';
import About from '../views/About.vue';
import News from '../views/News.vue';
import NewsDetail from '../views/NewsDetail.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', component: Home },
    { path: '/products', component: Products },
    { path: '/productsDetail', component: ProductsDetail },
    { path: '/productsModelDetail', component: ModelDetail },
    { path: '/solution', component: Solution },
    { path: '/solutionDetail', component: SolutionDetail },
    { path: '/news', component: News },
    { path: '/newsDetail', component: NewsDetail },
    { path: '/support', component: Support },
    { path: '/about', component: About }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    return {x: 0, y: 0}
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js